import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
var ClientOnlyPortal = function(param) {
    var children = param.children, selector = param.selector;
    var ref = useRef(null);
    var ref1 = useState(false), mounted = ref1[0], setMounted = ref1[1];
    useEffect(function() {
        ref.current = document.querySelector(selector);
        setMounted(true);
    }, [
        selector
    ]);
    return mounted && ref.current ? /*#__PURE__*/ createPortal(children, ref.current) : null;
};
export { ClientOnlyPortal };
